import api from './api.service';

class ConnectorService {
    static async getResult(id) {
        const res = await api.get(`${'connector/get'}/${id}`)
        try {
            return res.data;
        } catch (err) {
            return err;
        }
    }
}

export default ConnectorService;